import 'arrive';
import { gsap } from 'gsap'
import 'waypoints/lib/noframework.waypoints.min.js';

document.arrive('.split-scroller', {existing: true}, function(){

  const split = this;
  const section = this.closest('section');
  const box = section.querySelector('.box-layer');
  const layers = box.querySelectorAll('.background');

  new Waypoint({

    element: split,
    handler: function(direction) {

      if ( direction == 'down' ) {

        const timeL = gsap.timeline();

        if ( split.classList.contains('last') ) {
          box.style.position = 'absolute';
          box.style.top = 'initial';
          box.style.bottom = 0;
        }

        if ( split.classList.contains('first') ) {
          box.style.position = 'fixed';
        }

      }

    },

    offset: '0'

  });

  new Waypoint({

    element: split,
    handler: function(direction) {

      if ( direction == 'up' ) {

        const timeL = gsap.timeline();

        if ( split.classList.contains('first') ) {
          box.style.position = 'absolute';
          box.style.bottom = 'initial';
          box.style.top = 0;
        }

        if ( split.classList.contains('last') ) {
          box.style.position = 'fixed';
        }

      }

    },

    offset: '0'
  
  });



  new Waypoint({

    element: split,
    handler: function(direction) {

      if ( direction == 'down' ) {

        const indexS = split.dataset.split;

        if ( !split.classList.contains('first') ) {

          const layers_ = layers;

          layers_.forEach( background => {

            if ( background.classList.contains('active') ) {

              gsap.to(background, {
                autoAlpha: 0,
                duration: 0.6,
                onComplete: () => {
                  background.classList.remove('active');
                }
              });
            }

          });

          layers.forEach( background => {

            const indexB = background.dataset.background;

            if ( indexB == indexS ) {

              gsap.to(background, {
                autoAlpha: 1,
                duration: 0.6,
                onComplete: () => {
                  background.classList.add('active');
                }
              });

            }

          });

        }

      }

    },

    offset: '50%'

  });

  new Waypoint({

    element: split,
    handler: function(direction) {

      if ( direction == 'up' ) {

        const indexS = split.dataset.split;

        if ( !split.classList.contains('last') ) {

          const layers_ = layers;

          layers_.forEach( background => {

            if ( background.classList.contains('active') ) {

              gsap.to(background, {
                autoAlpha: 0,
                duration: 0.6,
                onComplete: () => {
                  background.classList.remove('active');
                }
              });
            }

          });

          layers.forEach( background => {

            const indexB = background.dataset.background;

            if ( indexB == indexS ) {

              gsap.to(background, {
                autoAlpha: 1,
                duration: 0.6,
                onComplete: () => {
                  background.classList.add('active');
                }
              });

            }

          });

        }

      }

    },

    offset: '-50%'

  });

});
